// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"ce5d1197","124":"32203a51","264":"537da49f","418":"de5a2e04","480":"62aa34f9","638":"54e5f3bd","787":"574a5eea"}[chunkId] + ".chunk.js";
};